import type { RequiredRouteParameter, RouteTemplate } from "@octopusdeploy/portal-routes";
import { isRouteParameter } from "@octopusdeploy/portal-routes";

export function formatRoutePath<T>(routeTemplate: RouteTemplate<T>, hasDescendantRoutes: boolean = false) {
    const routePath = routeTemplate.map((part) => (typeof part === "string" ? part : isRouteParameter(part) ? formatRouteParameter(part) : optionalSpaceIdForSystemRoutes)).join("");
    return hasDescendantRoutes ? `${routePath}/*` : routePath;
}

function formatRouteParameter<T extends string>(routeParameter: RequiredRouteParameter<T>) {
    // React router route parameters are prefixed with a ":"
    return `:${routeParameter.name}`;
}

const optionalSpaceIdForSystemRoutes = "/:spaceId?";
